import React from 'react';
import { Heart } from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';

/**
 * WishlistButton — small heart toggle for product cards + PDP.
 *
 * Props:
 *  product   : product object (id, name, images/media, price, currency, ...)
 *  size      : 'sm' | 'md' (default 'md')
 *  className : extra classes
 */
export const WishlistButton = ({ product, size = 'md', className = '' }) => {
  const { has, toggle } = useWishlist();
  if (!product?.id) return null;
  const active = has(product.id);
  const dims = size === 'sm' ? 'h-8 w-8' : 'h-10 w-10';
  const icon = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(product); }}
      aria-label={active ? 'Remove from wishlist' : 'Add to wishlist'}
      data-testid={`wishlist-btn-${product.id}`}
      className={`${dims} inline-flex items-center justify-center bg-[#F5EDDD]/90 backdrop-blur-sm border border-[#C9B596] hover:border-[#33200F] transition-colors ${className}`}
    >
      <Heart
        className={`${icon} transition-colors ${active ? 'fill-[#33200F] text-[#33200F]' : 'text-[#5B3A24]'}`}
        strokeWidth={1.6}
      />
    </button>
  );
};

export default WishlistButton;
